module.exports = __webpack_public_path__ + "img/2.05bf0118.png";